import { render } from "./CallLogs.vue?vue&type=template&id=e85dce92"
import script from "./CallLogs.vue?vue&type=script&lang=js"
export * from "./CallLogs.vue?vue&type=script&lang=js"

import "./CallLogs.vue?vue&type=style&index=0&id=e85dce92&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__